export class AdminManagerSearchModel {
  region?:string;
  area: string;
  areaId: string;
  branch: string;
  startDate: string;
  endDate: string;
  status: string | null;
  clientNumber: string | null;
  idNumber: string | null;
  branchSerial: string | null;

  lstBranches: any[] = [];

  quoteId: number;
  cancelReason: string | null;

  userName: any;
}
